import { useEffect, useState } from 'react';
import { AnswersContext } from './context';
import Navigation from './components/navigation/Navigation';
import Loader from './components/custom-components/loader/Loader';
import { UserDataProvider } from './context/UserDataProvider';

function App() {
    const isToken = localStorage.getItem('token') || sessionStorage.getItem('token') ? true : false;

    const [isAuth, setIsAuth] = useState(isToken);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (isLoading) {
            const delay = setTimeout(() => {
                setIsLoading(false);
            }, 1000);

            return () => {
                clearTimeout(delay);
            };
        }
    }, [isLoading]);

    const [userName, setUserName] = useState('');
    const [questions, setQuestions] = useState([]);

    if (isLoading) {
        return <Loader />;
    }

    return (
        <UserDataProvider isAuth={isAuth}>
            <AnswersContext.Provider
                value={{
                    isAuth,
                    setIsAuth,
                    userName,
                    questions,
                    setQuestions,
                    setUserName,
                }}
            >
                <Navigation isAuth={isAuth} />
            </AnswersContext.Provider>
        </UserDataProvider>
    );
}

export default App;
